import {
  VALIDATE_APPLICATION_POLICY,
  ValidateApplicationPolicyReqDto,
  ValidateApplicationPolicyResponse,
} from 'src/configs/APISchemas/ValidateUserPolicyGraphQL';
import { GraphQLRequest } from 'src/helpers/GraphQLRequest';

export const validateApplicationPolicy = async (
  dto: ValidateApplicationPolicyReqDto,
): Promise<
  ValidateApplicationPolicyResponse['validateApplicationPolicy'] | undefined
> => {
  const mutation = VALIDATE_APPLICATION_POLICY(dto);
  const response = await GraphQLRequest<ValidateApplicationPolicyResponse>(
    mutation,
  );

  return response?.validateApplicationPolicy;
};
